<script setup lang="ts">
import { orderList } from "~/constants/plan";

const router = useRouter();
const route = useRoute();

const selectOrder = computed(() => {
  const order = route.query.order ? route.query.order.toString() : "date";
  const asc = route.query.asc ? parseInt(route.query.asc.toString()) : 0;
  return orderList.find((e) => e.order == order && e.asc == asc)?.name;
});

function onSelectItem(name: string) {
  const item = orderList.find((e) => e.name == name);
  if (item) {
    router.push({
      query: { ...route.query, order: item?.order, asc: item?.asc, off: 0 },
    });
  }
}
</script>

<template>
  <DropdownMenu
    :size="18"
    :list="orderList"
    :selected="selectOrder"
    @onSelectName="onSelectItem($event)"
    class="border rounded"
  >
    <template v-slot:title>
      <p
        class="text-sm whitespace-nowrap overflow-hidden text-ellipsis pl-2 pr-4 py-2"
      >
        <Icon
          class="mr-2"
          size="20"
          :name="
            orderList.find((e) => e.name == selectOrder)?.asc
              ? 'mdi:sort-reverse-variant'
              : 'mdi:sort-variant'
          "
        />
        {{ orderList.find((e) => e.name == selectOrder)?.name }}
      </p>
    </template>
  </DropdownMenu>
</template>
